import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import { useAuth } from "../context/AuthContext";
import Loader from "../components/Loader";
import "./LoginPage.css";
import logo from "../assets/logo.png";
import axios from "axios";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoadingLogin(true);
  setError('');

  try {

    const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/login`, { email, password });
    console.log(process.env.REACT_APP_API_BASE_URL);
    const { user, token, company } = res.data; // ✅ include company
    login(user, token, company); // ✅ pass company here

    // Redirect based on role
    if (user.role === 'Admin') navigate('/admin');
    else if (user.role === 'SuperAdmin') navigate('/superadmin/dashboard');
    else navigate('/');
  } catch (err) {
    setError(err.response?.data?.error || 'Login failed');
  } finally {
    setLoadingLogin(false);
  }
};

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img
            src={logo}
            alt="Logo"
            className="login-logo"
          />
          <h2>Welcome</h2>
          <p className="subtitle">Sign in to continue to your dashboard</p>
        </div>

        <form onSubmit={handleSubmit}>
          {error && <p className="error">{error}</p>}

          <div className="input-container">
            <input
              type="email"
              id="email"
              placeholder=" "
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label htmlFor="email">Email</label>
          </div>

          <div className="input-container">
            <input
              type="password"
              id="password"
              placeholder=" "
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label htmlFor="password">Password</label>
          </div>

          <button type="submit" disabled={loadingLogin}>
            {loadingLogin ? "Logging in..." : "Login"}
          </button>

          {loadingLogin && (
            <div className="loader-overlay">
              <Loader />
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
